"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.createIVRApi = exports.IVRApiOptions = void 0;
var num_client_1 = require("num-client");
var IVRModuleHelper_1 = require("./IVRModuleHelper");
var IVRApiOptions = (function () {
    function IVRApiOptions(depth) {
        this.depth = depth;
        if (!Number.isInteger(this.depth) || this.depth < 0) {
            this.depth = 0;
        }
    }
    return IVRApiOptions;
}());
exports.IVRApiOptions = IVRApiOptions;
var createIVRApi = function (numClient) { return new IVRApiImpl(numClient); };
exports.createIVRApi = createIVRApi;
var IVRApiImpl = (function () {
    function IVRApiImpl(numClient) {
        this.client = numClient ? numClient : num_client_1.createClient();
    }
    IVRApiImpl.prototype.lookupUri = function (uri, options) {
        var theOptions = options ? new IVRApiOptions(options.depth) : new IVRApiOptions(Number.MAX_SAFE_INTEGER);
        var lookup = new Lookup({}, uri.withPort(num_client_1.MODULE_0));
        return retrieveRecord(this.client, lookup, new Map(), theOptions).then(function (result) {
            return result;
        });
    };
    IVRApiImpl.prototype.lookupPhoneNumber = function (phoneNumber, options) {
        return this.lookupUri(num_client_1.buildNumUri(phoneNumber), options);
    };
    return IVRApiImpl;
}());
var retrieveRecord = function (client, lookup, usedUris, optionsParam) {
    if (optionsParam.depth <= 0) {
        return Promise.resolve({});
    }
    var options = new IVRApiOptions(optionsParam.depth - 1);
    var uriString = JSON.stringify(lookup.uri);
    if (!usedUris.has(uriString)) {
        var promise = client.retrieveNumRecord(client.createContext(lookup.uri));
        usedUris.set(uriString, promise);
        return promise.then(function (ivr) {
            var obj = ivr !== null ? IVRModuleHelper_1.IVRModuleHelper.transform(JSON.parse(ivr)) : {};
            delete obj['@n'];
            for (var k in obj) {
                lookup.link[k] = obj[k];
                break;
            }
            return followLinks(client, usedUris, obj, lookup.uri, options);
        }, handleError);
    }
    else {
        var uriPromise = usedUris.get(uriString);
        return uriPromise.then(function (s) {
            if (s) {
                return Promise.resolve(JSON.parse(s));
            }
            return Promise.resolve(null);
        }, handleError);
    }
};
var followLinks = function (client, usedUris, jsonObj, currentUri, optionsParam) {
    var promises = findLinks(jsonObj, currentUri).map(function (l) {
        var lookup = new Lookup(l.link, l.uri.withPort(num_client_1.MODULE_0));
        return retrieveRecord(client, lookup, usedUris, optionsParam);
    });
    return Promise.all(promises).then(function () {
        return jsonObj;
    }, handleError);
};
var handleError = function (reason) {
    throw new Error(reason);
};
var findLinks = function (obj, uri) {
    var links = new Array();
    for (var k in obj) {
        if (obj['@L']) {
            var link = obj;
            var path = "" + link['@L'];
            var newUri = path.startsWith('num://')
                ? num_client_1.parseNumUri(path)
                : path.startsWith('/')
                    ? uri.withPath(new num_client_1.UrlPath(path))
                    : uri.path.s.endsWith('/')
                        ? uri.withPath(new num_client_1.UrlPath(uri.path.s + path))
                        : uri.withPath(new num_client_1.UrlPath(uri.path.s + '/' + path));
            links.push(new Link(link, newUri));
            delete obj['@L'];
        }
        else {
            var value = obj[k];
            if (value !== null && typeof value === 'object') {
                findLinks(value, uri).forEach(function (l) { return links.push(l); });
            }
        }
    }
    return links;
};
var Lookup = (function () {
    function Lookup(link, uri) {
        this.link = link;
        this.uri = uri;
    }
    return Lookup;
}());
var Link = (function () {
    function Link(link, uri) {
        this.link = link;
        this.uri = uri;
    }
    return Link;
}());
//# sourceMappingURL=IVRApi.js.map